var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header'),_c('main-menu'),_vm._m(0),_c('bottom-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagecontainer container"},[_c('div',{staticClass:"heading"},[_c('span',[_c('b',[_vm._v("Admin Corporate")])])])])
}]

export { render, staticRenderFns }